export var FTUE_STEPS_KEYS = {
  INITIAL: 0,
  HIGHLIGHT_A_GAME: 1,
  SHOW_IN_GAME: 2,
  CLICKED_ON_SPINNER: 3,
  FINISHED_AND_SHOW_POPUP: 4
};
export var FTUE_EVENT_TYPES = {
  START_FTUE_TUTORIAL: 'START_FTUE_TUTORIAL',
  FTUE_TUTORIAL_NEXT_STEP: 'FTUE_TUTORIAL_NEXT_STEP',
  DISPLAY_FTUE_TUTORIAL_STEP: 'DISPLAY_FTUE_TUTORIAL_STEP',
  FTUE_TUTORIAL_SKIP: 'FTUE_TUTORIAL_SKIP',
  FTUE_TUTORIAL_COMPLETE: 'FTUE_TUTORIAL_COMPLETE'
};